module.exports = __webpack_public_path__ + "img/banner5.990db80e.png";